document.addEventListener('DOMContentLoaded', function load() {
    if (!window.jQuery) return setTimeout(load, 50);
  
  
  	 var pw_button = $("#pw_cart_button");
     var staticProduct = $("#pw_static_product");
  
     if ($("body").hasClass("product") && (pw_button.length || staticProduct.length) ){
        setTimeout(function(){ 
       		$(".shopify-payment-button").hide();
         },1000);
       
       $(document).on("change", ".selector-wrapper select", function(e){
       	$(".shopify-payment-button").hide();
       });
     }

    if($("body").hasClass("product") && pw_button.length){
      $("body").addClass("pw-product");
        
      function personaliseButton(){

        $("body").on('DOMSubtreeModified', "#pw_personalisation_id", function() {

          var pw_button_text = $("#pw_cart_button").val();
          if(pw_button_text == "Create"){
            $('#pw_cart_button').val('Edit');
            setTimeout(function(){ 
              $(".pwAddToCart").show();
            },1000);
          } 

        });


        // Select the node that will be observed for mutations
        var targetNode = document.getElementById('pw_personalisation_id');

        // Options for the observer (which mutations to observe)
        var config = { attributes: true, childList: true };

        // Callback function to execute when mutations are observed
        var callback = function(mutationsList) {
          //for(var mutation of mutationsList) {
          for(var mutation in mutationsList) {

            var pw_button_text = $("#pw_cart_button").val();
            if(pw_button_text == "Create"){
              $('#pw_cart_button').val('Edit');
              setTimeout(function(){ 
                $(".pwAddToCart").show();
              },1000);
            }
          }

        };

        // Create an observer instance linked to the callback function
        var observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);

        var pw_button = $("#pw_cart_button");
        if (typeof pw_button  !== "undefined"){
          setTimeout(function(){
            $(".shopify-payment-button, .pwAddToCart").hide();
          },3000);

        }
      }

      personaliseButton();
      
     
      function pwVariationChange(){

        var pw_cart_button = $("#pw_cart_button").html();
        if (typeof  pw_cart_button !== 'undefined'){
          var pw_button_text = $("#pw_cart_button").val();
          if(pw_button_text == "Edit"){
			            
            var product_image_original = $('meta[property="og:image"]').attr('content');
			
            setTimeout(function(){ 
    
              $(".image__container img.lazyloaded").attr("data-src", product_image_original);
              $(".image__container img.lazyloaded").attr("data-bgset", product_image_original);
              $(".image__container img.lazyloaded").attr("src", product_image_original);
              $(".image__container img.lazyloaded").attr("srcset", product_image_original);
  
              $(document).on("click", ".Product__Slideshow img", function(e){
              	$(".pswp__img").attr("src", product_image_original);
              });

            }, 500);
           
            if (document.documentMode || /Edge/.test(navigator.userAgent)) {
              $("#pw_cart_button").prop('value', 'Create');
            } else{
              $('#pw_cart_button').val('Create');
            }
           
          }
          
          setTimeout(function(){ 
              $(".shopify-payment-button, .pwAddToCart").hide();             
           },500);
        }

      }
      
      $(".selector-wrapper select").on("change", function(e){
		
         pwVariationChange();

      });

    }
  	
  	function replacePWimages(){
      
      var textArray = $(".cart__item-list .cart__card .cart__info:contains('PersonalisationID')");

      textArray.each(function() {

        var cardID = this.innerText.match(/PersonalisationID:.*/);
        cardID = cardID[0];
        cardID = cardID.replace("PersonalisationID:", "").trim();
        cardID = cardID.match(/[^\s]+/);
        cardID = cardID[0];
        var rand = Math.floor(Math.random() * 10000);
        var newSrc = "https://pwcdn.net/thumbnails/708/"+cardID+".jpg?r="+rand;
        $(this).parent().find("img").addClass("pwThumbImage");
        $(this).parent().find("img").attr("src",newSrc);
        $(this).parent().find("img").attr("srcset",newSrc);
        
       

      });
      
    }
  
  function cartSidebar(){
      
      var textArray = $(".ajax-cart__list .ajax-cart__product.media .ajax-cart__line-item:contains('PersonalisationID')");
      textArray.each(function() {

        var cardID = this.innerText.match(/PersonalisationID:.*/);
        cardID = cardID[0];
        cardID = cardID.replace("PersonalisationID:", "").trim();
        cardID = cardID.match(/[^\s]+/);
        cardID = cardID[0];
        var rand = Math.floor(Math.random() * 10000);
        var newSrc = "https://pwcdn.net/thumbnails/708/"+cardID+".jpg?r="+rand;
        $(this).parent().parent().parent().find("img").addClass("pwThumbImage");
        $(this).parent().parent().parent().find("img").attr("src",newSrc);
        $(this).parent().parent().parent().find("img").attr("srcset",newSrc);
        
       

      });
      
    }
  
   $(".pwAddToCart").click(function(){
        setTimeout(function(){ 
      		cartSidebar();
      	}, 2000);
    }); 

  

  $(".icon.header__icon").mouseover(function(){
     setTimeout(function(){ 
      		cartSidebar();
      	}, 500);
  });
  

    if($("body").hasClass("cart")){
      setTimeout(function(){ 
      		replacePWimages();
      	}, 2000);

      $("#pw_modal").on('hidden.bs.modal', function() { 
          
          setTimeout(function(){ 
              replacePWimages();
          },1000);
      });
  }

}, false);

